import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: ComponentProps<'input'>) {
    return (
        <input
            type={type}
            data-slot="input"
            className={cn(
                // 2rem is the console's density; a finger needs 40px, so coarse pointers only.
                'flex h-8 pointer-coarse:h-10 w-full min-w-0 rounded-md border border-input bg-field px-2.5 py-1 text-sm shadow-xs',
                'transition-[color,box-shadow,border-color] duration-(--animate-duration)',
                'placeholder:text-muted-foreground',
                'selection:bg-primary selection:text-primary-foreground',
                'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
                // Field focus: the border turning solid indigo is the indicator; the soft halo is decoration.
                'outline-hidden focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/25',
                // Errors carry text as well as color; this only reinforces it.
                'aria-invalid:border-destructive aria-invalid:ring-[3px] aria-invalid:ring-destructive/20',
                'aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:ring-destructive/25',
                'disabled:cursor-not-allowed disabled:bg-surface-raised disabled:opacity-50 disabled:shadow-none',
                className
            )}
            {...props}
        />
    )
}

export { Input }
